import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api } from "../lib/api";
import { usePageMeta } from "../lib/usePageMeta";
import Header from "../components/Header";
import Footer from "../components/Footer";
import PostCard from "../components/PostCard";
import { Search as SearchIcon } from "lucide-react";

export default function Search() {
  usePageMeta("Buscar — Viagens Orion", "Encontre roteiros, destinos e dicas de viagem publicados pela equipe da Viagens Orion.");
  const [params, setParams] = useSearchParams();
  const initial = params.get("q") || "";
  const [q, setQ] = useState(initial);
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!initial) return;
    setLoading(true);
    api.get("/posts", { params: { q: initial, limit: 30 } })
      .then((r) => setPosts(r.data.items || []))
      .finally(() => setLoading(false));
  }, [initial]);

  const submit = (e) => {
    e.preventDefault();
    setParams({ q });
  };

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="container-orion py-16 md:py-24 flex-1" data-testid="search-page">
        <div className="max-w-2xl mb-12">
          <div className="cat-chip mb-3">Busca</div>
          <h1 className="font-serif text-2xl md:text-5xl font-semibold text-orion-purple mb-4 md:mb-6">O que você quer descobrir hoje?</h1>
          <form onSubmit={submit} className="flex items-center gap-3 border-b-2 border-orion-purple pb-2">
            <SearchIcon size={20} className="text-orion-purple" />
            <input
              value={q}
              onChange={(e) => setQ(e.target.value)}
              placeholder="Ex.: Fernando de Noronha, cruzeiro Mediterrâneo…"
              className="flex-1 bg-transparent outline-none text-lg py-2"
              data-testid="search-input"
              autoFocus
            />
            <button className="bg-orion-orange text-white px-5 py-2 text-xs uppercase tracking-widest hover:bg-[#E04828] transition-colors" data-testid="search-submit">
              Buscar
            </button>
          </form>
        </div>

        {loading && <div className="text-center py-16 text-[#8A8191]">Buscando…</div>}

        {!loading && initial && (
          <>
            <div className="text-sm text-[#594A63] mb-8">
              {posts.length} resultado{posts.length !== 1 ? "s" : ""} para <strong className="text-orion-purple">"{initial}"</strong>
            </div>
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-x-6 gap-y-10">
              {posts.map((p) => <PostCard key={p.id} post={p} />)}
            </div>
          </>
        )}
      </main>
      <Footer />
    </div>
  );
}
